import { render } from "./EpicItemTable.vue?vue&type=template&id=763df440&scoped=true"
import script from "./EpicItemTable.vue?vue&type=script&lang=js"
export * from "./EpicItemTable.vue?vue&type=script&lang=js"

import "./EpicItemTable.vue?vue&type=style&index=0&id=763df440&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763df440"]])

export default __exports__